// const accordion = () => {
// 	const accordions = document.querySelectorAll(".accordion-block");
// 	accordions.forEach((accordion) => {
// 		const accordionTitle = accordion.querySelector(".accordion__heading");
// 		const accordionContent = accordion.querySelector(".accordion__content");
// 		accordionTitle.addEventListener("click", () => {
// 			accordion.classList.toggle("active");
// 		});
// 	});
// };

// window.addEventListener("DOMContentLoaded", accordion);
